import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentBadge20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDocumentBadge20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.5 16.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V16H10a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H4.5V3.5a1 1 0 0 1 1-1h4.507v5.993H15.5zM3 11.268V3.5A2.5 2.5 0 0 1 5.5 1h5.078a2 2 0 0 1 1.406.578l4.422 4.373A2 2 0 0 1 17 7.373V16.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 16.5v-.768A2 2 0 0 1 2 14v-1a2 2 0 0 1 1-1.732m12.327-4.275-3.82-3.778v3.778zM4 12.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentBadge20);
